import { Component } from '@angular/core';
import { UserInfoComponent } from './user-info/user-info.component';
import { LanguageSwitchComponent } from './language-switch/language-switch.component';
import { ThemeSwitchComponent } from './theme-switch/theme-switch.component';
import { TimezoneIndicatorComponent } from './timezone-indicator/timezone-indicator.component';

@Component({
  selector: 'app-user-action',
  templateUrl: './user-action.component.html',
  styleUrls: ['./user-action.component.scss'],
  imports: [UserInfoComponent, LanguageSwitchComponent, ThemeSwitchComponent, TimezoneIndicatorComponent],
})
export class UserActionComponent {}
